// import { inject, PLATFORM_ID } from '@angular/core';
// import { CanActivateFn, Router } from '@angular/router';
// import { isPlatformBrowser } from '@angular/common';
// import { Auth } from '@angular/fire/auth';
// import { Firestore, doc, getDoc } from '@angular/fire/firestore';

// export const authGuard: CanActivateFn = async () => {

//   const platformId = inject(PLATFORM_ID);

//   if (!isPlatformBrowser(platformId)) {
//     return true;
//   }

//   const auth = inject(Auth);
//   const firestore = inject(Firestore);
//   const router = inject(Router);

//   try {
//     await auth.authStateReady();

//     const user = auth.currentUser;

//     if (!user) {
//       router.navigate(['/login']);
//       return false;
//     }

//     const snap = await getDoc(doc(firestore, 'users', user.uid));

//     if (!snap.exists() || !snap.data()?.['approved']) {
//       router.navigate(['/login']);
//       return false;
//     }

//     return true;

//   } catch (err) {
//     router.navigate(['/login']);
//     return false;
//   }
// };

import { inject, PLATFORM_ID } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { Auth } from '@angular/fire/auth';
import { Firestore, doc, getDoc } from '@angular/fire/firestore';
import { UserContextService } from './user-context.service';

export const authGuard: CanActivateFn = async () => {

  const platformId = inject(PLATFORM_ID);

  if (!isPlatformBrowser(platformId)) {
    return true;
  }

  const auth = inject(Auth);
  const firestore = inject(Firestore);
  const router = inject(Router);
  const userContext = inject(UserContextService);

  try {

    await auth.authStateReady();

    const user = auth.currentUser;

    if (!user) {
      router.navigate(['/login']);
      return false;
    }

    const snap = await getDoc(doc(firestore, 'users', user.uid));

    if (!snap.exists() || !snap.data()?.['approved']) {
      router.navigate(['/login']);
      return false;
    }

    // ✅ load and cache name
    await userContext.loadUserName();

    return true;

  } catch {
    router.navigate(['/login']);
    return false;
  }
};
